import {
  Box,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  VStack,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi"; // Standard, clean icon matching your theme
import { getProfile } from "../store/actionCreators/userAction";
import { ACCENT_2_COLOR, PRIMARY_COLOR, SECONDARY_COLOR } from "../constants/color";
import logo from "../assets/logo.png";
// import LoginModal from "./LoginModal";
import LanguageCombo from "./LanguageCombo";
import { useTranslation } from "react-i18next";
import LanguageStack from "./LanguageStack";

const Menubar = () => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const { isOpen: isOpenLogin, onOpen: onOpenLogin, onClose: onCloseLogin } = useDisclosure();
  
  // Disclosure for the Mobile Hamburger Drawer
  const { isOpen: isMobileOpen, onOpen: onMobileOpen, onClose: onMobileClose } = useDisclosure();

  // const { user } = useSelector((store) => store.rootReducer.userReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const aboutUsPaths = ["/mugai-ryu", "/tsuji-gettan", "/lineage", "/niina-soke", "/curriculum"];
  const access_token = localStorage.access_token;

  const pathNameMap = {
    "/": t("home"),
    "/mugai-ryu": t("aboutMugaiRyu"),
    "/tsuji-gettan": "Tsuji Getan",
    "/lineage": t("lineage"),
    "/curriculum": t("curriculum"),
    "/our-activities": t("ourActivities"),
    "/our-dojos": t("ourDojo"),
    "/contact": t("contact")
  };

  useEffect(() => {
    if (access_token) {
      dispatch(getProfile());
    }
  }, [access_token, dispatch]);

  const handleMobileNav = (path) => {
    navigate(path);
    onMobileClose();
  };

  // const handleLogout = () => {
  //   console.log(user, 'ini user')
  //   localStorage.removeItem("access_token");
  //   dispatch(logout());
  //   navigate("/");
  // }

  return (
    <Box w={"100vw"} height={{ base: "120px", md: "150px" }} alignItems={"center"} display={"flex"} flexDir={"column"}>
      
      {/* Logo Wrapper Area */}
      <Box w={"100vw"} height={{ base: "70px", md: "100px" }} display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <Image src={logo} width={{ base: "40px", md: "50px" }} alt="Dojo Logo" />
      </Box>

      {/* Main Bar Navigation Container */}
      <Box 
        w={"100vw"} 
        height={"50px"} 
        alignItems={"center"} 
        display={"flex"} 
        justifyContent={{ base: "space-between", md: "center" }}
        px={{ base: "24px", md: "0px" }}
        bgColor={PRIMARY_COLOR}
      >
        {/* DESKTOP VIEWPORT: Displays standard menu bar */}
        <Box
          display={{ base: "none", md: "flex" }}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box w={"8vw"}></Box>
          <Box w={"84vw"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
              <Text 
                fontSize={"24px"} 
                onClick={() => navigate("/")} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                {t("home")}
              </Text>
            </Box>

            <Menu isOpen={isOpen} onClose={onClose}>
              <MenuButton 
                onClick={onOpen} 
                _hover={{ textColor: ACCENT_2_COLOR }} 
                fontSize={"24px"} 
                textColor={aboutUsPaths.includes(location.pathname) ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                mx={"24px"} 
                className="cormorant-garamond-normal"
              >
                {t("aboutUs")}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => navigate("/mugai-ryu")}><Text className="cormorant-garamond-normal">{t("aboutMugaiRyu")}</Text></MenuItem>
                <MenuItem onClick={() => navigate("/tsuji-gettan")}><Text className="cormorant-garamond-normal">Tsuji Getan</Text></MenuItem>
                <MenuItem onClick={() => navigate("/lineage")}><Text className="cormorant-garamond-normal">{t("lineage")}</Text></MenuItem>
                <MenuItem onClick={() => navigate("/curriculum")}><Text className="cormorant-garamond-normal">{t("curriculum")}</Text></MenuItem>
              </MenuList>
            </Menu>

            <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
              <Text 
                fontSize={"24px"} 
                onClick={() => navigate("/our-activities")} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/our-activities" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                {t("ourActivities")}
              </Text>
            </Box>

            <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
              <Text 
                fontSize={"24px"} 
                onClick={() => navigate("/our-dojos")} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/our-dojos" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                {t("ourDojo")}
              </Text>
            </Box>

            <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
              <Text 
                fontSize={"24px"} 
                onClick={() => navigate("/equipment")} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/equipment" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                {t("equipment")}
              </Text>
            </Box>

            <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
              <Text 
                fontSize={"24px"} 
                onClick={() => navigate("/contact")} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/contact" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                {t("contact")}
              </Text>
            </Box>
          </Box>
          {/* {!user.role && ( <Box w={"8vw"} >
            <Text 
                fontSize={"24px"} 
                onClick={onOpenLogin} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/our-activities" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                Login
            </Text>
          </Box> )}
          {user.role && ( <Box w={"8vw"} >
            <Text 
                fontSize={"24px"} 
                onClick={handleLogout} 
                _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                textColor={location.pathname === "/our-activities" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                className="cormorant-garamond-normal"
              >
                Logout
            </Text>
          </Box> )} */}
          <Box w={"8vw"} display={"flex"} justifyContent={"right"} alignItems={"center"} pr={"12px"}>
            <LanguageCombo />
          </Box>
        </Box>

        {/* {user?.role === "admin" && (
                <Box
                  display={{ base: "none", md: "flex" }}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                    <Box w={"8vw"}></Box>
                    <Box w={"84vw"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                      <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
                        <Text 
                          fontSize={"24px"} 
                          onClick={() => navigate("/admin/kenshi")} 
                          _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                          textColor={location.pathname === "/admin/kenshi" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                          className="cormorant-garamond-normal"
                        >
                          Kenshi List
                        </Text>
                      </Box>
                      <Box mx={{ base: "12px", md: "12px", lg: "24px" }}>
                        <Text 
                          fontSize={"24px"} 
                          onClick={() => navigate("/admin/video")} 
                          _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                          textColor={location.pathname === "/admin/video" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                          className="cormorant-garamond-normal"
                        >
                          Video List
                        </Text>
                      </Box>
                    </Box>
                    <Box w={"8vw"} >
                      <Text 
                          fontSize={"24px"} 
                          onClick={handleLogout} 
                          _hover={{ cursor: "pointer", textColor: ACCENT_2_COLOR }} 
                          textColor={location.pathname === "/our-activities" ? ACCENT_2_COLOR : SECONDARY_COLOR} 
                          className="cormorant-garamond-normal"
                        >
                          Logout
                      </Text>
                    </Box>
                </Box>
        )} */}

        {/* MOBILE VIEWPORT: Displays side-scrolling drawer toggle button */}
        <Box display={{ base: "flex", md: "none" }} w="100%" justifyContent="space-between" alignItems="center">
          <Text fontSize="20px" textColor={SECONDARY_COLOR} className="cormorant-garamond-normal">
            {pathNameMap[location.pathname] || "Menu"}
          </Text>
          <Box display={"flex"} alignItems={"center"}>
            <LanguageCombo />
            <IconButton
              aria-label="Open Navigation Menu"
              icon={<GiHamburgerMenu size={24} />}
              onClick={onMobileOpen}
              variant="ghost"
              color={SECONDARY_COLOR}
              _hover={{ bg: "transparent", textColor: ACCENT_2_COLOR }}
              _active={{ bg: "transparent" }}
            />
          </Box>
        </Box>
      </Box>

      {/* Responsive Mobile Navigation Drawer menu */}
      <Drawer isOpen={isMobileOpen} placement="right" onClose={onMobileClose}>
        <DrawerOverlay />
        <DrawerContent bg={PRIMARY_COLOR} color={SECONDARY_COLOR}>
          <DrawerCloseButton color={SECONDARY_COLOR} size="lg" mt="8px" />
          <DrawerHeader borderBottomWidth="1px" borderColor={ACCENT_2_COLOR} className="cormorant-garamond-normal" fontSize="24px" textColor={ACCENT_2_COLOR}>
            Navigation
          </DrawerHeader>

          <DrawerBody py="24px">
            <VStack spacing="24px" align="stretch">
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/")} _hover={{ textColor: ACCENT_2_COLOR }} textColor={location.pathname === "/" ? ACCENT_2_COLOR : SECONDARY_COLOR} >
                {t("home")}
              </Text>
              
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/mugai-ryu")} textColor={location.pathname === "/mugai-ryu" ? ACCENT_2_COLOR : SECONDARY_COLOR} >
                {t("aboutMugaiRyu")}
              </Text>
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/tsuji-gettan")} textColor={location.pathname === "/tsuji-gettan" ? ACCENT_2_COLOR : SECONDARY_COLOR} >
                Tsuji Getan
              </Text>
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/lineage")} textColor={location.pathname === "/lineage" ? ACCENT_2_COLOR : SECONDARY_COLOR} >
                {t("lineage")}
              </Text>
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/curriculum")} textColor={location.pathname === "/curriculum" ? ACCENT_2_COLOR : SECONDARY_COLOR} >
                {t("curriculum")}
              </Text>

              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/our-activities")} _hover={{ textColor: ACCENT_2_COLOR }}>
                {t("ourActivities")}
              </Text>
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/our-dojos")} _hover={{ textColor: ACCENT_2_COLOR }}>
                {t("ourDojo")}
              </Text>
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/equipment")} _hover={{ textColor: ACCENT_2_COLOR }}>
                {t("equipment")}
              </Text>
              <Text fontSize="22px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/contact")} _hover={{ textColor: ACCENT_2_COLOR }}>
                {t("contact")}
              </Text>

              <LanguageStack />

              {/* {user?.role === "admin" && (
                <Box borderTop="1px solid" borderColor={ACCENT_2_COLOR} pt="16px">
                  <Text fontSize="18px" fontWeight="bold" mb="8px" textColor={ACCENT_2_COLOR}>Admin Menu</Text>
                  <VStack spacing="12px" align="stretch" pl="8px">
                    <Text fontSize="18px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/admin/kenshi")}>Kenshi List</Text>
                    <Text fontSize="18px" className="cormorant-garamond-normal" onClick={() => handleMobileNav("/admin/video")}>Video List</Text>
                  </VStack>
                </Box>
              )} */}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      {/* <LoginModal isOpen={isOpenLogin} onClose={onCloseLogin} /> */}
    </Box>
  );
};

export default Menubar;